<template>
<v-container fluid>
  <v-row>
    <v-col cols="2">
      <v-row>
        <v-col cols="12">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="400px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="train_date" prepend-icon="event" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="train_date" no-title @input="fillTrains()"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-data-table :headers="headers" :items="trains" :search="search" v-model="selected"
           show-select mutiple @item-selected = "itemSelected($event)" dense
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50]}" :items-per-page="20" sort-by="trains" class="elevation-1" :loading="isLoading" loading-text="Loading... Please wait" :mobile-breakpoint="100">
                      <template v-slot:no-data>
                        <v-btn color="primary" @click="fillTrains()">No Trains, click to retry</v-btn>
                      </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="10">
      <div class="chartdiv">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </div>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import {
  Chart
} from 'highcharts-vue'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

export default {
  name: 'speedcharthigh_multiple',
  components: {
    highcharts: Chart
  },
  data() {
    return {
      search: '',
      selected: [],
      headers: [{
          text: 'Train No',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'ORG',
          value: 'org'
        },
        {
          text: 'DEST',
          value: 'dest'
        },

      ],
      train: {},
      train_loading: false,
      trains: [],
      train_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      train_no: null,
      errors: [],
      series: [],
      chartOptions: {
        chart: {
          events: {
            load() {
              this.showLoading();
            }
          },
          height: '48%',
          type: 'line',
          zoomType: 'x',
          panning: true,
          panKey: 'shift'
        },
        title: {
          text: 'Speed Chart(drag select to zoom, press shit key to pan)'
        },

        time: {
          timezone: 'Asia/Kolkata',

        },
        xAxis: {
          type: 'datetime',
          labels: {
            formatter: function() {
              // var lt = moment(this.value).format("YYYY-MM-DD HH:mm:ss")
              // var testDateUtc = moment.utc(lt);
              // var localDate = moment(testDateUtc).local();
              return moment.utc(this.value).format("HH:mm:ss")
            },
          },
          title: {
            text: 'Time'
          }
        },
        tooltip: {
          formatter: function() {
            var lt = moment(this.x).format("YYYY-MM-DD HH:mm:ss")
            var testDateUtc = moment.utc(lt);
            var localDate = moment(testDateUtc).local();
            return 'Speed ' + this.y + ' KMPH, Time ' + moment.utc(this.x).format("HH:mm:ss")
          }
        },
        yAxis: {
          title: {
            text: 'Speed(KMPH)'
          },
          min: 0
        },
        series: []
      }
    }
  },

  mounted() {
    this.fillTrains()
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep', 'actDep', 'actArr', 'curPosStartId', 'curPosDestId', 'curPositions']),
  },
  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr']),
    fillData(p) {
      //    console.log(p)
      var that = this
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/positions`, {
          params: p
        })
        .then(response => {
          // console.log(response.data)
          var speed_data = []
          var time_data = []
          var series_data = []
          var zones = [{
            value: 2,
            color: '#FF0000'
          }, {
            value: 15,
            color: '#FF7F00'
          }, {
            value: 40,
            color: '#FFD700'
          }, {
            value: 60,
            color: '#9ACD32'
          }, {
            value: 80,
            color: '#00FF00'
          }, {
            value: 90,
            color: '#008080'
          }, {
            color: '#FF00FF'
          }]
          var offset = new Date(response.data[0].fixtime).getTime() - 60000
          _.forEach(response.data, function(o) {
            var speed = o.speed
            switch (o.deviceid) {
              case 3:
              case 10:
              case 11:
              case 13:
                break;
              default:
                speed = that.round(speed * 1.852, 2)
            }
            speed_data.push(speed)
  //          time_data.push(o.fixtime)
            series_data.push([new Date(o.fixtime).getTime()-offset, speed])
            // console.log(time_data,new Date(time_data[10]).getTime(),new Date(time_data[100]).getTime())
            })
            that.series.push({
              name: 'Train No ' + p.train_no,
              data: series_data,
              // zones: zones,
              color: that.getRandomColor()
            })
            console.log(that.series)
            this.chartOptions = {
              subtitle: {
                text: `Date: ${moment(this.trian_date).format("DD/MM/YYYY")}, Multiple Trains`
              },
              xAxis: {
                categories: time_data,
              },
              series: that.series, // sample data
            }
          this.$refs.chart.chart.hideLoading();
        })
        .catch(e => {
          console.log(e)
        })
    },
    fillTrains() {
      this.menu1 = false
      this.train_loading = true
      this.trains = []
      var p = {
        train_date: this.train_date,
      }
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/reportforperiod`, {
          params: p
        })
        .then(response => {
          this.trains = response.data
          this.train_loading = false
          })
        .catch(e => {
          console.log(e)
          this.train_loading = false
        })
    },
    itemSelected(value) {
      if (value.value) {
        var p = {
          train_date: moment(this.train_date).format("YYYY-MM-DD"),
          train_no: value.item.train_no,
          device_id: value.item.device_id,
          org: value.item.org,
          dep: moment(value.item.dep).add(-3, "m").format(),
          dest: value.item.dest,
          arr: moment(value.item.arr).add(30, "m").format(),
        }
        this.fillData(p)
      } else {
        this.series = this.series.filter(function(el) { return el.name != 'Train No ' + value.item.train_no; });
        this.chartOptions = {
          subtitle: {
            text: `Date: ${moment(this.curTrainDate).format("DD/MM/YYYY")}, Train No: ${this.train_no}`
          },
          series: this.series, // sample data
        }
      }
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    getFormattedTime(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("DD/MM/YYYY")
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    makeColor(colorNum, colors) {
      if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
      return "hsl(" + (colorNum * (360 / colors) % 360) + ",70%, 90%)";
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

  }
}
</script>

<style>
.chartdiv {
  width: 100%;
  height: 100%;
  margin: 5px;
  overflow: auto;
}
</style>
